import logo from './logo.svg';
import './App.css';
import Navbar from "./components/Navbar"
import Profile from './components/profile';
import About from './components/About';
import Skills from './components/Skills';
import { useState } from 'react';
import Projects from './components/Projects';
import Experience from './components/Experience';
import Footer from './components/footer';
import {GitHub}  from "./components/github.jsx"

function App() {
  const [elem,setelem]=useState(0)
console.log(elem)
  const handleclick=(num)=>{
    setelem(num)
  }

  return (
    <div className="App">
      <Navbar setelem={setelem}/>
      <Profile/>
      <About/>
      <Skills/>
      <Projects/>
     <GitHub/>
      <Experience/>
      <Footer/>
    </div>
  );
}

export default App;
